import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import BootstrapTable from 'react-bootstrap-table-next';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../subscriptions.css';
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
// import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


class ViewCalculators extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (

    <div className="modal fade" id="view_calculators_modal" tabIndex="-1" role="dialog" aria-labelledby="RejectModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Calculators Details</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="form-group m-form__group row">
                                    <label className="col-lg-4 col-form-label">Calculator Name:</label>
                                <div className="col-lg-8">formula 1</div>
                            </div>
                            <div className="m-form__seperator m-form__seperator--dashed my-3"></div>
                                <h5>Use Formula for Usage</h5>
                            <div className="form-group m-form__group row">
                                <label className="col-lg-4 col-form-label">Strength:</label>
                                <div className="col-lg-8">300 mg/ 7 ml</div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label className="col-lg-4 col-form-label">Dose:</label>
                                <div className="col-lg-8">12 mg/ 2 lb 3x a day</div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label className="col-lg-4 col-form-label">Duration:</label>
                                <div className="col-lg-8">6 - 14 days</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
                

    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(ViewCalculators));